import { render } from "./OpenGymFaq.vue?vue&type=template&id=6a222d65&scoped=true"
import script from "./OpenGymFaq.vue?vue&type=script&lang=js"
export * from "./OpenGymFaq.vue?vue&type=script&lang=js"

import "./OpenGymFaq.vue?vue&type=style&index=0&id=6a222d65&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a222d65"]])

export default __exports__